import { render, staticRenderFns } from "./FormImagemContentComponent.vue?vue&type=template&id=0b45c390&scoped=true"
import script from "./FormImagemContentComponent.vue?vue&type=script&lang=js"
export * from "./FormImagemContentComponent.vue?vue&type=script&lang=js"
import style0 from "./FormImagemContentComponent.vue?vue&type=style&index=0&id=0b45c390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45c390",
  null
  
)

export default component.exports